import type { RawAxiosRequestHeaders } from 'axios';
import axios from 'axios';
import type { CartItem, MergeToCart } from 'types';

import mergeToCardUtil from './mergeToCardUtil';

const otherMergeToCard = async (mergeToCart: MergeToCart, newItems: CartItem[]) => {
  const payload = mergeToCardUtil.generatePayload(newItems, mergeToCart.mapperCode);
  if (mergeToCart.mergeOneByOne) {
    for (const item of payload) {
      if (mergeToCart.isClientSideCall) {
        await mergeToCardUtil.addToCard(item, mergeToCart.clientSideMethod);
      } else {
        const headers: RawAxiosRequestHeaders = {};
        headers['Content-Type'] = mergeToCart.requestContendType || 'application/json';
        await axios.post(mergeToCart.path!, item, { headers });
      }
    }
    return;
  }
  if (mergeToCart.isClientSideCall) {
    await mergeToCardUtil.addToCard(payload, mergeToCart.clientSideMethod);
  } else {
    const headers: RawAxiosRequestHeaders = {};
    headers['Content-Type'] = mergeToCart.requestContendType || 'application/json';
    await axios.post(mergeToCart.path!, payload, { headers });
  }
};
export default otherMergeToCard;
